/* Digitizing guidance. Uses the existing storefront shell; no artwork submission or automatic fee. */
(()=>{
 'use strict';
 const servicePath='/products/digitizing-fee';
 function syncServicePage(){
  const page=document.querySelector('#digitizing-page');if(!page)return;const native=document.querySelector('#ps-server-product');if(native)native.hidden=true;
  const active=location.pathname.replace(/\/$/,'')===servicePath&&(!location.hash||location.hash==='#digitizing');
  document.body.classList.toggle('ps-digitizing-service-page',active);page.hidden=!active;
  if(active){document.querySelectorAll('main:not(#digitizing-page)').forEach(main=>main.hidden=true);const footer=document.querySelector('#footer');if(footer)footer.hidden=false;document.body.classList.remove('in-studio');}
 }
 const setupNote="Your design may require a setup fee.";
 function ensure(){
  document.querySelectorAll('.ps-digitizing-guide').forEach(el=>el.remove());
  document.querySelectorAll('#studio-page [data-ps-setup-fee-note]').forEach(el=>el.remove());
  const notes=Array.from(document.querySelectorAll('#product-page [data-ps-setup-fee-note]'));
  const pdp=document.querySelector('#product-page:not([hidden])');if(!pdp){notes.forEach(el=>el.remove());return;}
  const detail=pdp.querySelector('.catalog-detail'),custom=pdp.querySelector('#catalog-customize');
  const model=(window.PS_CATALOG||[]).find(p=>String(p.id)===String(detail?.dataset.productId));
  const blank=detail?.dataset.finish==='blank'||model?.blankOnly||!!(model&&window.PS_SEO?.record?.(model)?.custom===false);
  const description=pdp?.querySelector('.pdp-model-story .ps-seo-overview');
  if(!description||blank||!custom||custom.hidden){notes.forEach(el=>el.remove());return;}
  let note=notes.find(el=>el.parentElement===description);notes.forEach(el=>{if(el!==note)el.remove();});
  if(!note){note=document.createElement('p');note.setAttribute('data-ps-setup-fee-note','true');note.textContent=setupNote;description.append(note);}
  else if(note.textContent!==setupNote)note.textContent=setupNote;
 }
 let queued=false;const queue=()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;ensure();});}};
 syncServicePage();ensure();window.addEventListener('hashchange',()=>{syncServicePage();queue();});new MutationObserver(queue).observe(document.body,{childList:true,subtree:true});
})();
